import verifyTokenGuardWithoutPermission from '@/guards/verifyTokenGuardWithoutPermission'

export default {
    name: 'security',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'security-settings',
            beforeEnter: [verifyTokenGuardWithoutPermission],
            component: () => import(/* webpackChunkName: "security-settings" */ '@/modules/security/views/SecuritySettingsView.vue'),
        },
    ],
}
